import AnimationsOnScroll from "./AnimationsOnScroll";
import Animations from "./Animations";
import Swiper from 'swiper/bundle';
import "../css/style.scss"

import Swip from "./modules/swiper"

const app = {

  homeBanner: () => {

    if (document.querySelector('.main-banner')) {

      var slider = new Swiper ('.main-banner', {
      slidesPerView: 1,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      speed: 1000,
      autoplay: {
          delay: 5000,
      },
    });


    }

  },

  search: () => {

    let search_box = document.querySelector('.header__right__search');

    if (search_box) {


      let modal = search_box.querySelector('.search__drop');

      search_box.addEventListener('click', openModal);

      window.addEventListener('click', outsideClick);

      function openModal(){
        search_box.classList.add('active')
        let input = search_box.querySelector('.is-search-input');
        input.focus();
      }

      function outsideClick(e){
        if (!search_box.contains(event.target)) {
          search_box.classList.remove('active');
        }
      }

   }
  },

  tabSwitcher: () => {
    let tabsWrapper = document.querySelectorAll('.tabs-wrapper');
  
    if (tabsWrapper) {
      tabsWrapper.forEach(tabWrapper => {
        const tabs = tabWrapper.querySelectorAll('.styl1[data-tab-target]');
        const tabContents = tabWrapper.querySelectorAll('.styl1[data-tab-content]');
  
        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget);
            const isActive = tab.classList.contains('active');
  
            if (isActive) {
              // If the clicked tab is already active, remove the active class
              tab.classList.remove('active');
              target.classList.remove('active');
            } else {
  
              // Add the active class to the clicked tab and its corresponding content
              tab.classList.add('active');
              target.classList.add('active');
            }
          });
        });
      });
    }
  },  
  

  tabSwitcher2: () => {

    let tabsWrapper = document.querySelectorAll('.tabs-wrapper2');

    if (tabsWrapper) {
      tabsWrapper.forEach(tabWrapper => {

        const tabs = tabWrapper.querySelectorAll('.styl2[data-tab-target]')
        const tabContents = tabWrapper.querySelectorAll('.styl2[data-tab-content]')

        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget)
            tabContents.forEach(tabContent => {
              tabContent.classList.remove('active')
            })
            tabs.forEach(tab => {
              tab.classList.remove('active')
            })
            tab.classList.add('active')
            target.classList.add('active')
          })
        })

       });
    }

  },

  tabSwitcher3: () => {

    let tabsWrapper = document.querySelectorAll('.tabs-wrapper3');

    if (tabsWrapper) {
      tabsWrapper.forEach(tabWrapper => {

        const tabs = tabWrapper.querySelectorAll('.styl1[data-tab-target]')
        const tabContents = tabWrapper.querySelectorAll('.styl1[data-tab-content]')

        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget)
            tabContents.forEach(tabContent => {
              tabContent.classList.remove('active')
            })
            tabs.forEach(tab => {
              tab.classList.remove('active')
            })
            tab.classList.add('active')
            target.classList.add('active')
          })
        })

       });
    }

  },

  mobileMenu: () => {

   let buttons = document.querySelectorAll('.header-mobile__cont .header__right__menu__item--sub .button-cat');

    if (buttons) {
      console.log(buttons);
      buttons.forEach(button => {
 
          button.addEventListener('click', (e) => {
            e.preventDefault();
            var panel = button.nextElementSibling;
            if (panel.classList.contains("list-visible")) {
              panel.classList.remove("list-visible");
            } else {
              panel.classList.add("list-visible");
            }
          })
      });



    }

  },

  mobileMenuBack: () => {
    let back = document.querySelectorAll('.header-mobile__goback');
    if (back) {

      back.forEach(btn => {
      
        btn.addEventListener('click', () => {
         
          btn.closest('.header__right__menu__sub').classList.remove('list-visible');
   
        });
  
      });

    }

  },

  showMobileMenu: () => {
    let mobileMenu = document.querySelector('.header-mobile__cont');
    let hamburger = document.querySelector('#opener');
    
    if (hamburger) {
     
          hamburger.addEventListener('click', () => {
            mobileMenu.classList.toggle('active');
            hamburger.classList.toggle('active');
            document.body.classList.toggle('body-no-scroll');
          });

        }
    },

  showMobileSearch: () => {
    let mobileSearch = document.querySelector('.search__drop__cont.mobile');
    let close = document.querySelector('.btn-search');
    let elementToRemoveActive = document.querySelector('.header__right__lang__dropd__sub.mobile');
    if (close) {
      
          close.addEventListener('click', () => {
            mobileSearch.classList.toggle('active');
            close.classList.toggle('active');
            elementToRemoveActive.classList.remove('active');
          });

        }
    },

  showMobileLang: () => {
    let mobileLang = document.querySelector('.header__right__lang__dropd__sub.mobile');
    let close2 = document.querySelector('.header__right__lang.mobile');
    let elementToRemoveActive2 = document.querySelector('.search__drop__cont.mobile');
    
    if (close2) {
      close2.addEventListener('click', () => {
        mobileLang.classList.toggle('active');
        close2.classList.toggle('active');
        elementToRemoveActive2.classList.remove('active');
      });
    }
  },

  init: () => {
    AnimationsOnScroll.init();

    app.search();
    app.tabSwitcher();
    app.tabSwitcher2();
    app.tabSwitcher3();
    app.homeBanner();
    app.mobileMenu();
    app.mobileMenuBack();
    app.showMobileMenu();
    app.showMobileSearch();
    app.showMobileLang();
  }
};

const mainSw = new Swip()

document.addEventListener("DOMContentLoaded", () => {
	app.init();

});